import React, { memo, useMemo } from "react";
import { DatePicker, DatePickerProvider } from "@origin-digital/ods-pickers";
import { parse } from "date-fns";
import { latestEligibleDateOfBirth } from "./validation";

// ODS recreates its text-field slot on render. Isolate it from unrelated
// form blur updates so a click retains keyboard focus and opens the calendar.
export const DateOfBirthField = memo(
  ({ value, error }: { value: string; error?: string }) => {
    const latestBirthDate = useMemo(() => latestEligibleDateOfBirth(), []);
    const date = useMemo(
      () => (value ? parse(value, "dd/MM/yyyy", new Date()) : null),
      [value]
    );
    return (
      <DatePickerProvider>
        <DatePicker
          id="jah-dateOfBirth"
          data-id="jah-dateOfBirth-picker"
          label="Date of birth"
          variant="responsive"
          format="dd/MM/yyyy"
          defaultValue={date}
          minDate={parse("01/01/1900", "dd/MM/yyyy", new Date())}
          maxDate={latestBirthDate}
          error={!!error}
          helperText={error || "DD/MM/YYYY. Must be 16 or older."}
          muiProps={{
            openTo: "year",
            referenceDate: latestBirthDate,
            views: ["year", "month", "day"],
            slotProps: {
              textField: { id: "jah-dateOfBirth" },
              openPickerButton: { id: "jah-dateOfBirth-open" },
            },
          }}
        />
      </DatePickerProvider>
    );
  }
);
DateOfBirthField.displayName = "DateOfBirthField";
